module.exports = __webpack_public_path__ + "img/mobile-52.17a17519.png";